import { Injectable } from '@angular/core';
import { INDDReportLanguageProvider } from '@ndk/ng-reports/config';
import { LocalStorageService } from '@ndk/ng-storage';

import { LocalStorageKeys } from '@core/storage/local-storage.enum';

@Injectable()
export class ReportLanguageService implements INDDReportLanguageProvider {
    constructor(private localStorage: LocalStorageService) { }

    public getCurrentLanguage(): string { // TODO: criar testes de unidade
        return this.localStorage.getValue(LocalStorageKeys.CurrentLanguage);
    }
}
